import { instantSchema, uuidSchema } from '@der-maschinfuehrer/contracts';
function defaultUuid() {
    if (typeof globalThis.crypto?.randomUUID !== 'function') {
        throw new Error('crypto.randomUUID is required for local database mutations');
    }
    return uuidSchema.parse(globalThis.crypto.randomUUID());
}
function defaultNow() {
    return instantSchema.parse(new Date().toISOString());
}
export function createRuntime(overrides = {}) {
    return {
        now: overrides.now ?? defaultNow,
        uuid: overrides.uuid ?? defaultUuid,
        ...(overrides.fault === undefined ? {} : { fault: overrides.fault }),
        ...(overrides.pause === undefined ? {} : { pause: overrides.pause }),
    };
}
//# sourceMappingURL=runtime.js.map